
define('text!templates/modals/select-deal/goods-collection.ejs',[],function () { return '    <tbody>\n    </tbody>';});

